// import React from 'react'

const t = {
    FR: {
        'Your are connected.': 'Vous êtes connecté.',
        'More to come soon for this page.': 'Plus à venir bientôt pour cette page.',
    },
    EN: {
        'Your are connected.': 'Your are connected.',
        'More to come soon for this page.': 'More to come soon for this page.',
    },
    ES: {
        'Your are connected.': 'Estas conectado.',
        'More to come soon for this page.': 'Más por venir pronto para esta página.',
    },
    PT: {
        'Your are connected.': 'Você está conectado(a).',
        'More to come soon for this page.': 'Novidades em breve nessa página',
    },
}

export default t